import { getProjectId } from 'jcb-token-kit'
import { getLastMonthEndDate } from './time'

export const linkType = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
}

export const linkTarget = {
  CURRENT: 1,
  NEW: 2,
}

export const resourceType = {
  QUEST: 'QUEST',
  QUESTION: 'QUESTION',
  USER: 'USER',
  FILE: 'FILE',
}

export const urlMap = {
  home: '/home',
  quest: '/quest',
  question: '/question',
  user: '/user',
  file: '/file',
}

export const MENU_OPTS = {
  BLANK: '_blank',
}

export const FORM_TYPE = {
  SELECT: 'select',
  TREE: 'tree',
  STANDARD: 'standard',
  NUMBER: 'number',
  STRING: 'string',
  BOOLEAN: 'boolean',
  TIME: 'time',
  IMAGE: 'image',
  FILE: 'file',
  MEDIA: 'media',
  MATRIX: 'matrix',
  JSON: 'json',
  BUTTON: 'button',
  VIDEO: 'video',
  TREESELECT: 'tree-select',
  LNGLAT: 'lnglat',
}

export const FORM_BOOL_TRUE = 'true'
export const FORM_BOOL_FALSE = 'false'

export const FORM_TIME_FORMAT = {
  DATE: 'date',
  DATETIME: 'date-time',
  TIME: 'time',
}

export const FORM_ITEM_LAYOUT = {
  HORIZON: 'horizon',
  VERTICAL: 'vertical',
}

// 暂用
export const FORM_ITEM_SPAN = {
  HORIZON: 18,
  VERTICAL: 20,
}

// 之前用作opts中的数据，现改作验证选项
export const CUSTOM_FORM_OPTS = {
  [FORM_TYPE.SELECT]: {
    MULTIPLE: 'multiple',
    ETC: 'etc',
    DROPDOWN: 'dropdown',
    LIST: 'list',
  },
  [FORM_TYPE.TREE]: {
    MULTIPLE: 'multiple',
    ASYNC: 'async',
  },
  [FORM_TYPE.STRING]: {
    MINLEN: 'minlen',
    MAXLEN: 'maxlen',
    FORMAT: 'format',
  },
  COMMON: {
    REQUIRED: 'required',
  },
}

export const CUSTOM_FORM_ERR_MSG = {
  [FORM_TYPE.STRING]: {
    [CUSTOM_FORM_OPTS[FORM_TYPE.STRING].MINLEN]: '字数不能少于{0}',
    [CUSTOM_FORM_OPTS[FORM_TYPE.STRING].MAXLEN]: '字数不能多于{0}',
    [CUSTOM_FORM_OPTS[FORM_TYPE.STRING].FORMAT]: '模式不匹配',
  },
  COMMON: {
    REQUIRED: '该项不能为空',
  },
}

export const CUSTOM_FORM_REQUIRED = {
  [FORM_TYPE.SELECT]: ['selects'],
  [FORM_TYPE.TREE]: ['nodes'],
}

export const FORM_SCHEMA_CONDITION = {
  EQUAL: 'equal',
  EXIST: 'exist',
  LT: 'lt',
  GT: 'gt',
  INCLUDE: 'include',
}

export const CONDITION_OPTS = {
  CONDITION: 'condition',
  OR: 'or',
  AND: 'and',
}

export const MSG_SHOW_TIME = 1.5

export const COMMON_MODAL_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
}

export const OPEN_TYPE = {
  DRAWER: 'drawer',
  DIALOG: 'dialog',
  BLANK: 'blank',
  SELF: 'self',
}

export const SUBMIT_OPTS = {
  REFRESH: 'refresh',
  CLOSE: 'close',
}

export const PROJECT = {
  COMMON: 'COMMON',
  WJLJFL: 'WJLJFL',
}

export const ATTANDENCE_STATUS = {
  accept: '已通过',
  reject: '已拒绝',
  need_review: '待审核',
}

export const STAGE = {
  REVIEW: 'review',
  STREET_REVIEW: 'streetReview',
}

export const ROLE = {
  STREET: 'street',
  COMPANY: 'company',
}

export const OSS_PREFIX = 'https://ugm.oss-cn-beijing.aliyuncs.com'

export const apiV1 = '/api/v1'
export const apiV2 = '/api/v2'
export const apiMock = '/api/mock'
export const apiLocal = '/api/local'
export const apiReport = '/api/report'
export const imgUrl = 'http://test.qyconsult.treeyee.com:3000/img/setting'

// const companyid = sessionStorage.getItem('companyid')
// const companyid = getCompanyId() || 0
// 返回调研工场工作台
export const backtextPro = 'http://sw.treeyee.com/user/workbench/home'

//  检查吧落地页登录
export const proLogin = `http://sw.treeyee.com/login?url=${encodeURIComponent(
  'http://pro.jianchaba.com/'
)}`

// 调研工场的落地页
export const Landingpage = 'http://sw.treeyee.com'
// 登录页
export const Loginpage = 'http://sw.treeyee.com/login'

export const downloadTest =
  'https://ugm.oss-cn-beijing.aliyuncs.com/ele_download/common/win32/%E4%B8%8B%E8%BD%BD%E5%99%A8%20Setup%201.1.3.exe'

export const downloadRelease =
  'https://ugm.oss-cn-beijing.aliyuncs.com/ele_download/common/production/%E4%B8%8B%E8%BD%BD%E5%99%A8%E6%AD%A3%E5%BC%8F%E7%89%88%20Setup%201.1.9.exe'

export const getProjectFun = {
  70: {
    allowMap: false,
    allowImport: true,
    allowDownload: false,
    allowMultiAction: false,
    allowPolygon: false,
    allowRePoints: false,
  },
  8: {
    allowMap: true,
    allowImport: false,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: true,
    allowRePoints: true,
  },
  // 朝阳农委随手拍
  472: {
    allowMap: true,
    allowImport: true,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  1238: {
    allowMap: true,
    allowImport: true,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  1044: {
    allowMap: false,
    allowImport: false,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  1255: {
    allowMap: true,
    allowImport: true,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  1256: {
    allowMap: true,
    allowImport: true,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  1259: {
    allowMap: true,
    allowImport: false,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  // 上庄
  1104: {
    allowMap: true,
    allowImport: true,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  // 资源管理
  1530: {
    allowMap: true,
    allowImport: true,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  1908: {
    allowMap: true,
    allowImport: true,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
  default: {
    allowMap: true,
    allowImport: false,
    allowDownload: true,
    allowMultiAction: true,
    allowPolygon: false,
    allowRePoints: false,
  },
}

export const amapkey = '0e4f7b5e424e7db93755cb5d48e71a75'

export const QuestionTest = 'https://fangzhou.survey.work'
export const QuestionRelease = 'https://wj.survey.work'
export const JcbName =
  process.env.REACT_APP_TYPE === 'city'
    ? '实地检查-清研文明城市（区）创建智慧管理系统'
    : '调研工厂-明察暗访'

export const ucaseName = () => {
  if (['1351'].indexOf(getProjectId()) !== -1) {
    return '问题'
  }
  return '案件'
}

export const canDrawMap = () => {
  let arr = []
  if (process.env.REACT_APP_JCB_ENV === 'dev') {
    arr = [
      '1266',
      '1267',
      '1268',
      '1269',
      '1270',
      '1271',
      '1272',
      '1273',
      '1274',
      '1275',
      '1276',
      '1277',
      '1278',
      '1279',
      '1324',
      '1325',
      '1326',
      '1327',
      '1328',
      '1329',
      '1330',
      '1332',
      '1333',
      '1334',
      '1335',
      '1338',
      '1339',
      '1340',
      '1341',
      '1342',
      '1343',
      '1344',
    ]
  } else {
    arr = [
      '1378',
      '1380',
      '1396',
      '1397',
      '1398',
      '1399',
      '1400',
      '1401',
      '1402',
      '1403',
      '1404',
      '1405',
      '1406',
      '1407',
      '1408',
      '1409',
      '1410',
      '1411',
      '1412',
      '1413',
      '1414',
      '1415',
      '1416',
      '1417',
      '1418',
      '1419',
      '1420',
      '1421',
      '1422',
      '1432',
    ]
  }
  if (arr.indexOf(getProjectId()) !== -1) {
    return true
  }
  return false
}

export const canImport = () => {
  let arr = []
  if (process.env.REACT_APP_JCB_ENV !== 'dev') {
    arr = [
      '1622',
      '1597',
      '1540',
      '1539',
      '1527',
      '1374',
      '1366',
      '1365',
      '1364',
      '1363',
      '1362',
      '1359',
      '1350',
      '1348',
      '1347',
      '1346',
      '1291',
      '1261',
      '1260',
      '1252',
      '1241',
      '1125',
      '1114',
      '1099',
      '1048',
      '1047',
      '1046',
      '1703',
      '1738',
      '1739',
      '1812',
      '1817',
      '1976',
      '1979',
      '1989',
      '1990',
      '2070',
      '1',
      '8',
      '2150',
      '2430',
      '2532',
      '2775',
      '2783',
    ]
  } else {
    arr = ['1430', '1', '8', '1460', '1484']
  }
  if (arr.indexOf(getProjectId()) !== -1) {
    return true
  }
  return false
}
// 接诉即办表格
export const tableObj = (val) => {
  const obj = {
    tit: '',
    type: '',
  }
  switch (val) {
    case '镇科室':
      obj.tit = '各科室镇级三率办理情况'
      obj.type = 1
      break
    case '镇社区':
      obj.tit = '各村（社区）镇级三率办理情况'
      obj.type = 2
      break
    case '区科室':
      obj.tit = '各科室区级三率办理情况'
      obj.type = 3
      break
    case '区社区':
      obj.tit = '各村（社区）区级三率办理情况'
      obj.type = 4
      break
    default:
      break
  }
  return obj
}

export const historyUcaseTime = () => {
  const id = getProjectId()
  let datestring = []
  switch (id) {
    case '1':
      datestring = ['2019-01-01 00:00:00', `${getLastMonthEndDate()} 23:59:59`]
      break
    case '1431':
      datestring = ['2021-01-01 00:00:00', '2021-12-31 23:59:59']
      break
    default:
      datestring = ['2021-01-01 00:00:00', '2021-12-31 23:59:59']
      break
  }
  return { st: datestring[0], et: datestring[1], datestring }
}
